import React, {Component} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {sharedLabelsPath} from "../../../reducers/common/localization";
import FormWrapper from "../../commonComponents/formWrapper/FormWrapper.container";
import OrgFinanceManagement from './../orgFinanceManagement/OrgFinanceManagement.container';
import PageNotFoundComponent from '../../commonComponents/pageNotFoundComponent/PageNotFoundComponent.container';
import BackButtonComponent from "../../commonComponents/backButtonComponent/BackButtonComponent";
import {Col, Row} from "reactstrap";
import './OrgPaymentsDetails.css';
import {LABEL_PATH_BY_ORG_TYPE} from "../../../reducers/organization/organizations";

class OrgPaymentsDetails extends Component {
    componentWillMount() {
        this.props.onMount(this.props.id);
    }

    componentWillUnmount() {
        this.props.onUnmount();
    }

    render() {
        if (this.props.fetchingError) {
            return <PageNotFoundComponent/>;
        }

        if (this.props.loading && _.isNil(this.props.data)) {
            return (
                <div className="org-details-status-message-container">
                    <h6>{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>
                </div>
            );
        }

        return (
            <div className="org-details-container">
                <FormWrapper
                    successMessage={_.get(this.props.translation, 'finance.change_finance_success_message')}
                >
                    <div className="org-details-form">
                        <BackButtonComponent path='/organizations-payments'
                                             label={_.get(this.props.translation, sharedLabelsPath.back_button)}/>
                        <h4 className="page-label">{this.props.orgName} {_.get(this.props.translation, 'finance.label')}</h4>
                        {this.renderOrgData()}
                        <OrgFinanceManagement id={this.props.id}/>
                    </div>
                </FormWrapper>
            </div>
        );
    }

    renderOrgData = () => {
        if (_.isNil(this.props.data)) {
            return;
        }


        let paramsList = [
            {
                key: "orgType",
                title: _.get(this.props.translation, 'orgs.org_type_label'),
                value: _.get(this.props.translation, sharedLabelsPath[LABEL_PATH_BY_ORG_TYPE[this.props.data.orgType]])
            },
            {
                key: "orgName",
                title: _.get(this.props.translation, 'orgs.name_label'),
                value: this.props.data.orgName
            },
            {
                key: "anchor",
                title: _.get(this.props.translation, "orgs.anchor_label"),
                value: {
                    name: this.props.data.anchorName,
                    email: this.props.data.anchorEmail
                }
            },
            {
                key: "continent",
                title: _.get(this.props.translation, sharedLabelsPath.continent_label),
                value: _.get(this.props.translation, 'continents.' + this.props.data.orgContinent)
            },
            {
                key: "country",
                title: _.get(this.props.translation, sharedLabelsPath.country_label),
                value: _.get(this.props.translation, 'countries.' + this.props.data.orgCountry)
            }
        ];

        return [..._.map(paramsList, this.getDataRow)];
    };

    getAnchorDataRow = (params) => {
        return (
            <Row className="org-details-form-field-container" key={params.key}>
                <Col sm={4}>
                    {params.title}
                </Col>
                <Col>
                    {params.value.name + ', '}
                    <a href={"mailto:" + params.value.email}>{params.value.email}</a>
                </Col>
            </Row>
        );
    };

    getDataRow = (params) => {
        if (_.isNil(params.value)) {
            return null;
        }

        if (params.key === "anchor") {
            return this.getAnchorDataRow(params);
        }

        return (
            <Row className="org-details-form-field-container" key={params.key}>
                <Col sm={4}>
                    {params.title}
                </Col>
                <Col>
                    {params.value}
                </Col>
            </Row>
        );
    };
}

OrgPaymentsDetails.propTypes = {
    id: PropTypes.string,
    data: PropTypes.object,
    orgName: PropTypes.string,
    loading: PropTypes.bool,
    fetchingError: PropTypes.string,
    translation: PropTypes.object,
    onMount: PropTypes.func,
    onUnmount: PropTypes.func
};

export default OrgPaymentsDetails;



// WEBPACK FOOTER //
// ./src/components/organizationManagement/orgPaymentsDetails/OrgPaymentsDetails.js